module.exports = __webpack_public_path__ + "img/ls.8183e87a.svg";